import { render, staticRenderFns } from "./SupportCategorySelect.vue?vue&type=template&id=acc1a678&scoped=true&"
import script from "./SupportCategorySelect.vue?vue&type=script&lang=js&"
export * from "./SupportCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc1a678",
  null
  
)

export default component.exports